import { useCallback, useEffect, useRef } from "react";

/**
 * Guards a report's data requests against out-of-date answers.
 *
 * Call `begin()` right before starting a request. It returns `isCurrent()`;
 * once a newer request has started (or the screen is gone) `isCurrent()` is
 * false, and the older request must not touch the screen any more. Without
 * this, a slow answer for old filters can arrive after the answer for the
 * current filters and overwrite it.
 */
const useLatestRequest = () => {
  const latest = useRef(0);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return useCallback(() => {
    latest.current += 1;
    const mine = latest.current;
    return () => mounted.current && mine === latest.current;
  }, []);
};

export default useLatestRequest;
